module.exports = __webpack_public_path__ + "static/media/picto-inspiration-feed-white.735f6a4c.svg";